/**
 * returns data type of object passed in.
 *
 * @module classof
 * @param {Object}
 *
 * @example classof(null);		// => "Null"
 * @example classof(1);			// => "Number"
 * @example classof("");		// => "String"
 * @example classof(false);		// => "Boolean"
 * @example classof({});		// => "Object"
 * @example classof([]);		// => "Array"
 * @example classof(/./);		// => "Regexp"
 * @example classof(Date());	// => "Date"
 * @example classof(window);	// => "Window" (a client-side host object when dealing with a web view)
 * @example function(){};		// Define a custom constructor
 * @example classof(f());		// => "Object"
 */

const classof = o => Object.prototype.toString.call(o).slice(8, -1);

export default classof;
